import React from 'react';
import { trackEvent } from '../../hooks/useMetaPixel';
import { cn } from '../../lib/utils'; // We'll assume a utility or just inline it if simple, but I'll write the class logic inline for simplicity here since I can't create a utils file easily without an extra step.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'urgent' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withMicrocopy?: boolean;
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withMicrocopy = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]';
  const variants = {
    primary: 'bg-[#4A6741] text-white hover:bg-[#3A5233] shadow-lg shadow-[#4A6741]/20',
    secondary: 'bg-[#F5F2EA] text-[#4A6741] border-2 border-[#4A6741] hover:bg-[#EBE5D5]',
    urgent: 'bg-[#C06C54] text-white hover:bg-[#A65B46] shadow-lg shadow-[#C06C54]/20 animate-pulse-slow',
    outline: 'bg-transparent border-2 border-[#4A6741] text-[#4A6741] hover:bg-[#4A6741]/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl uppercase tracking-wide'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  // Simple class joiner since we don't have clsx/tailwind-merge installed by default
  const classes = [baseStyles, variants[variant], sizes[size], widthClass, className].join(' ');
  return <div className={`flex flex-col items-center ${fullWidth ? 'w-full' : ''}`} data-id="element-303">
      <a href="https://momentumdigitalpro.com/cart/44794015678566:1" target="_blank" rel="noopener noreferrer" className={classes} onClick={() => {
      trackEvent('AddToCart', {
        content_name: 'Cosmética Natural y Artesanal en Casa',
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }} data-id="element-304">
        {children}
      </a>
      {withMicrocopy && <span className="mt-2 text-[10px] md:text-xs text-gray-500 font-medium flex items-center gap-1.5 opacity-90" data-id="element-305">
          <svg className="w-3 h-3 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-306">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-307" />
          </svg>
          Descarga inmediata • Acceso por correo • Un solo pago
        </span>}
    </div>;
}